module.exports = __webpack_public_path__ + "img/allo-logo-grape.96722b40.svg";